var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1920 1080","preserveAspectRatio":"none"}},[_c('defs',[_c('filter',{attrs:{"id":"menu-blur","x":"0","y":"0"}},[_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}})],1)]),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"0","width":"1920","height":"1080","filter":"url(#menu-blur)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }